export default __webpack_public_path__ + "static/media/mso_icon2.7bc6327b.svg";